export const menuItems = [];

export default menuItems;
